import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";

// Define a tilt animation
const tilt = keyframes`
  0% { transform: rotate(-5deg); }
  50% { transform: rotate(5deg); }
  100% { transform: rotate(-5deg); }
`;

const Loading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", 
      }}
    >
      <Box
        component="img"
        src="/assets/images/osa-logo.svg" 
        alt="Loading"
        sx={{
          width: 200,
          height: 'auto',
          animation: `${tilt} 0.7s infinite ease-in-out`,
        }}
      />
    </Box>
  );
};

export default Loading;
